(function () {
    'use strict';

    function requestForProposalStateService($rootScope, $log, requestForProposalDataService, notifyService, sessionDataService) {
        var state = this;
        state.rfp = {};

        // Wrapping it in the session call for now
        function update(rfp, silent) {
            return sessionDataService.loadSession().then(function (sessionData) {
                return updateWithSessionData(rfp, silent, sessionData);
            });
        }

        function updateWithSessionData(rfp, silent, sessionData) {
            state.rfp = rfp;

            state.rfp.ResponseContent.InformationParts.forEach(function (informationPart) {
                informationPart.Access = {
                    View: true,
                    Edit: true
                };
                if (informationPart.BlobSummaries) {
                    informationPart.BlobSummaries.forEach(function (blob) {
                        blob.Access = {
                            View: true,
                            Edit: true
                        };
                        blob.UploadedByCleanName = blob.UploadedByEntity
                            ? blob.UploadedByEntity.Contact.FirstName + ' ' + blob.UploadedByEntity.Contact.LastName
                            : 'N/A';
                    });
                }
            });

            state.rfp.InformationParts.forEach(function (informationPart) {
                informationPart.Access = {
                    View: true,
                    Edit: true
                };
                if (informationPart.BlobSummaries) {
                    informationPart.BlobSummaries.forEach(function (blob) {
                        blob.Access = {
                            View: true,
                            Edit: true
                        };
                        blob.UploadedByCleanName = blob.UploadedByEntity
                            ? blob.UploadedByEntity.Contact.FirstName + ' ' + blob.UploadedByEntity.Contact.LastName
                            : 'N/A';
                    });
                }
            });

            var ownerEntityId = rfp.EntityId;
            var accessingEntityId = rfp.EntityId;

            if (ownerEntityId !== accessingEntityId) {
                if (sessionData.IsAdminEntity) {
                    state.rfp.AccessLevel = "ProjectAdmin";
                }
                else {
                    $rootScope.$broadcast('response_error');
                    $log.error("You cannot access this rfp");
                }
            }
            else {
                state.rfp.AccessLevel = "ProjectOwner";
            }

            if (!silent) {
                requestForProposalDataService.saveRequestForProposal(state.rfp).then(function (data) {
                    // TODO: Do we need anything here?
                }, function (error) {
                    // TODO: Handle potential concurrency issues
                    notifyService.notify('We could not save the changes to your rfp.', true);
                });
            }

            $rootScope.$broadcast('rfpUpdated');
            return state.rfp;
        }

        function get() {
            return state.rfp;
        }

        function addInformationPartToRfpContent(informationPart) {
            state.rfp.InformationParts.push(informationPart);
            update(state.rfp);
            notifyService.notify('You added ' + informationPart.Prompt);
        }

        function addInformationPartToResponseContent(informationPart) {
            state.rfp.ResponseContent.InformationParts.push(informationPart);
            update(state.rfp);
            notifyService.notify('You added ' + informationPart.Prompt);
        }

        function removeInformationPartFromRfpContent(informationPart, informationPartIndex) {
            state.rfp.InformationParts[informationPartIndex].IsRemoved = true;
            update(state.rfp);
            notifyService.notify('You deleted ' + informationPart.Prompt);
        }

        function removeInformationPartFromResponseContent(informationPart, informationPartIndex) {
            state.rfp.ResponseContent.InformationParts[informationPartIndex].IsRemoved = true;
            update(state.rfp);
            notifyService.notify('You deleted ' + informationPart.Prompt);
        }

        function deleteUploadForRfpContent(informationPart, blobIndex) {
            var matchingInformationPart = state.rfp.InformationParts.find(function(part) {
                return part.Title === informationPart.Title;
            });

            matchingInformationPart.BlobSummaries[blobIndex].IsRemoved = true;
            update(state.rfp);
            notifyService.notify('You deleted ' + matchingInformationPart.BlobSummaries[blobIndex].FileName);
        }

        function deleteUploadForResponseContent(informationPart, blobIndex) {
            var matchingInformationPart = state.rfp.ResponseContent.InformationParts.find(function (part) {
                return part.Title === informationPart.Title;
            });

            matchingInformationPart.BlobSummaries[blobIndex].IsRemoved = true;
            update(state.rfp);
            notifyService.notify('You deleted ' + matchingInformationPart.BlobSummaries[blobIndex].FileName);
        }

        function syncRfpContentQuestionSet(questionSet) {
            var informationPartIndex = state.rfp.InformationParts.map(function (part) {
                return part.Title;
            }).indexOf(questionSet.Title);
            state.rfp.InformationParts[informationPartIndex] = questionSet;
            update(state.rfp);
        }

        function syncRfpResponseQuestionSet(questionSet) {
            var responseContentInformationPartIndex = state.rfp.ResponseContent.InformationParts.map(function (part) {
                return part.Title;
            }).indexOf(questionSet.Title);
            state.rfp.ResponseContent.InformationParts[responseContentInformationPartIndex] = questionSet;
            update(state.rfp);
        }

        function updateDocumentPromptForRfpContent(document) {
            var informationPart = state.rfp.InformationParts.find(function(part) {
                return document.Title = part.Title;
            });

            informationPart.Prompt = document.Prompt;
            update(state.rfp);
        }

        function updateDocumentPromptForResponseContent(document) {
            var informationPart = state.rfp.ResponseContent.InformationParts.find(function(part) {
                return document.Title = part.Title;
            });
            informationPart.Prompt = document.Prompt;
        }

        return {
            update: update,
            get: get,
            addInformationPartToRfpContent: addInformationPartToRfpContent,
            addInformationPartToResponseContent: addInformationPartToResponseContent,
            removeInformationPartFromRfpContent: removeInformationPartFromRfpContent,
            removeInformationPartFromResponseContent: removeInformationPartFromResponseContent,
            deleteUploadForRfpContent: deleteUploadForRfpContent,
            deleteUploadForResponseContent: deleteUploadForResponseContent,
            syncRfpContentQuestionSet: syncRfpContentQuestionSet,
            syncRfpResponseQuestionSet: syncRfpResponseQuestionSet,
            updateDocumentPromptForRfpContent: updateDocumentPromptForRfpContent,
            updateDocumentPromptForResponseContent: updateDocumentPromptForResponseContent
        };
    }

    requestForProposalStateService.$inject = ['$rootScope', '$log', 'requestForProposalDataService', 'notifyService', 'sessionDataService'];

    angular.module('ecap.requestForProposal').factory('requestForProposalStateService', requestForProposalStateService);
})();
